export default __webpack_public_path__ + "static/media/TheinhardtPan-MediumItalic.db2a97f1.otf";